import {
  faChevronLeft,
  faChevronRight
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import Button from '../../base/Button';
import { useWizardFormContext } from '../../../providers/WizzardFormProvider';

const WizardFormFooter = ({
  className,
  nextBtnLabel = 'Next',
  hidePrevBtn,
  handleSubmit,
  beforeNext
}) => {
  const { selectedStep, goToStep, getCanNextPage, getCanPreviousPage } =
    useWizardFormContext();

  return (
    <div
      className={classNames(className, 'd-flex justify-content-between mb-0')}
    >
      <Button
        variant="link"
        className={classNames('p-0', {
          'd-none': hidePrevBtn || !getCanPreviousPage
        })}
        startIcon={<FontAwesomeIcon icon={faChevronLeft} className="fs-10" />}
        onClick={() => goToStep(selectedStep - 1)}
      >
        Previous
      </Button>
      <Button
        variant="primary"
        className={classNames('px-6', {
          'ms-auto': !hidePrevBtn
        })}
        endIcon={<FontAwesomeIcon icon={faChevronRight} className="fs-10" />}
        onClick={() => {
          // Gate advancing/submitting (e.g. every execution must have a machine).
          // beforeNext returns false to block; undefined callers are unaffected.
          if (typeof beforeNext === 'function' && !beforeNext(selectedStep)) {
            return;
          }
          if (getCanNextPage) {
            goToStep(selectedStep + 1);
          } else {
            if (handleSubmit) {
              handleSubmit();
            }
          }
        }}
      >
        {nextBtnLabel}
      </Button>
    </div>
  );
};

export default WizardFormFooter;
